import type { UseRefinementListProps } from 'react-instantsearch';

import { splitAmpersandTopics } from '../../utils';
import { TOPICS_LAUNCH_PAD_CONSTANTS } from './constants';

const transformFeaturedTopics: UseRefinementListProps['transformItems'] =
  items => {
    const itemsMap = items.reduce((acc, item) => {
      acc[item.value.toLowerCase()] = item;
      return acc;
    }, {});

    return TOPICS_LAUNCH_PAD_CONSTANTS.TOPICS.map(topic => {
      const splitTopics = splitAmpersandTopics([topic]);
      const item = splitTopics.map(t => itemsMap[t.toLowerCase()])[0];

      return item
        ? {
            ...item,
            displayLabel: topic
          }
        : {
            value: topic,
            label: topic,
            count: 0,
            isRefined: false,
            displayLabel: topic
          };
    });
  };

export { transformFeaturedTopics };
